export default __webpack_public_path__ + "static/media/logo.04af760c.png";